import { supabase } from '../supabase';

export async function awardXP(amount, source) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    const displayName = localStorage.getItem('vozoly_display_name') || 'Learner';

    const targetLanguage = (localStorage.getItem('vozoly_target_language') || 'italian').toLowerCase();

    await supabase.from('xp_log').insert({
        user_id: user.id,
        source,
        amount,
        target_language: targetLanguage,
    });

    const { data: existing } = await supabase
        .from('user_stats')
        .select('total_xp')
        .eq('user_id', user.id)
        .maybeSingle();

    await supabase.from('user_stats').upsert({
        user_id: user.id,
        total_xp: (existing?.total_xp || 0) + amount,
        display_name: displayName,
        updated_at: new Date().toISOString(),
    }, { onConflict: 'user_id' });
}

export function getTodayChallengeGame() {
    const games = ['word-search', 'word-wheel', 'flashcard-sprint'];
    const today = new Date();
    const dayNum = Math.floor(today.getTime() / 86400000);
    return games[dayNum % games.length];
}

export async function isDailyChallengeComplete() {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return false;
    const today = new Date().toISOString().split('T')[0];
    const { data } = await supabase
        .from('daily_challenge_completions')
        .select('id')
        .eq('user_id', user.id)
        .eq('challenge_date', today)
        .maybeSingle();
    return !!data;
}

export async function completeDailyChallenge(game) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return false;
    const today = new Date().toISOString().split('T')[0];
    const { data: already } = await supabase
        .from('daily_challenge_completions')
        .select('id')
        .eq('user_id', user.id)
        .eq('challenge_date', today)
        .maybeSingle();
    if (already) return false;
    await supabase.from('daily_challenge_completions').insert({
        user_id: user.id,
        challenge_date: today,
        game,
    });
    await awardXP(50, 'daily_challenge');
    return true;
}